<template lang="pug">
    div
        // wafRuleList
        // 外部列表
        Card(v-for="(wafRule, index) in localValue" :key="index" dis-hover)
            Row(type="flex" justify="space-between" align="middle")
                Col
                    Icon.wafRuleList-card-ios-radio-button-on(type="ios-radio-button-on" :color="getWafRuleStatusColor(wafRule)")
                    span {{ wafRule.name }}
                Col
                    Button(@click="editWafRule(index)") {{ $t("rcmtable.editText")}}
                    Button(@click="deleteWafRule(index)") {{ $t("rcmtable.deleteText")}}
        Button(@click="addWafRule()") {{ $t("rcmtable.addTagText")}}
        // 新增、編輯 Modal
        Modal(v-model="isWafRuleModalShow" :title="wafRuleModalTitle" :closable="false" :mask-closable="false" width="700")
            Form(ref="wafRuleModalForm" :model="localValue[editingWafRuleIndex]" v-if="isWafRuleModalShow" label-position="left" :label-width="120")
                Row(v-for="field in wafRuleFields" :key="field.key")
                    Col(span="24")
                        FormItem(
                            :label="field.label"
                            :prop="field.key"
                            :rules="field.validate"
                        )
                            component(
                                :is="field.formRender"
                                v-model="localValue[editingWafRuleIndex][field.key]"
                                :formData="localValue[editingWafRuleIndex]"
                                :formItem="field"
                                @request-validate="handleChildComponentValidate"
                                :ref="field.key === 'rules' ? 'rulesRef' : ''"
                                :groupName="formData.groupName"
                            )
            div(slot="footer")
                Button(@click="cancelEditOrAddWafRule()") {{$t('rcmtable.cancelText')}}
                Button(@click="confirmEditOrAddWafRule()") {{$t('rcmtable.confirmText')}}
</template>
<script>
import { colorNames } from "@/libs/rcmTableFieldsFunction";
import FormInput from "@/components/rcmTableFormItems/Input";
import FormSwitch from "@/components/rcmTableFormItems/Switch";

export default {
    name: "wafRuleList",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        formData: {},
    },
    components: { FormInput, FormSwitch },
    data() {
        return {
            // ====== 新增、編輯相關 ======
            localValue: JSON.parse(JSON.stringify(this.value)),
            isEditWafRule: false,
            editingWafRuleIndex: null,
            maxWafRuleListLength: 3,
            // ====== Modal 相關 ======
            isWafRuleModalShow: false,
            // ====== wafRuleList 裡的欄位 ======
            wafRuleFields: [
                {
                    label: this.$t("intelligentProtectionSettings.wafRule.name.label"),
                    key: "name",
                    formRender: "FormInput",
                    placeholder: this.$t("intelligentProtectionSettings.wafRule.name.placeholder"),
                    validate: [
                        {
                            required: true,
                            message: this.$t("rcmtable.required"),
                            trigger: "blur",
                        },
                    ],
                },
                {
                    label: this.$t("intelligentProtectionSettings.wafRule.isEnabled.label"),
                    key: "isEnabled",
                    formRender: "FormSwitch",
                    watchField: function (item) {},
                    validate: [],
                },
                {
                    label: this.$t("intelligentProtectionSettings.wafRule.rules.label"),
                    key: "rules",
                    formRender: () => import("@/components/FormItems/wafRuleList/rules.vue"),
                    validate: [],
                },
            ],
        };
    },
    computed: {
        wafRuleModalTitle() {
            return this.isEditWafRule
                ? this.$t("intelligentProtectionSettings.editWafRule")
                : this.$t("intelligentProtectionSettings.addWafRule");
        },
    },
    methods: {
        getEmptyWafRule() {
            return {
                name: "",
                isEnabled: true,
                rules: [
                    {
                        type: "action",
                        name: "00",
                        isPositive: true,
                        ip: [],
                        uri: [],
                        headers: [],
                        headersExist: [],
                        country: [],
                        isp: [],
                        proxyType: [],
                        ja3Hashes: [],
                        httpMethod: [],
                        rateLimitCount: 0,
                        rateLimitWindow: 0,
                        rateLimitToken: {
                            group: true,
                            ruleName: true,
                            ip: true,
                            host: true,
                            uri: false,
                            method: false,
                            country: false,
                            ua: false,
                            // customSign: false,
                            // customSignValue: "",
                        },
                        denyHtmlPageName: "default",
                        denyThenBucket: false,
                        denyThenBucketRateLimitCount: 0,
                        denyThenBucketRateLimitWindow: 0,
                        bucketTime: 300,
                        bucketPreSslDeny: false,
                        bucketPreSslDenyThreshold: 0,
                        globalBucketRecord: false,
                        withL3BucketList: false,
                        speedLimit: 10240,
                        redirectUrl: {},
                        redirectHttpCode: 302,
                        setReqHeaders: [],
                        setResHeaders: [],
                        customHtmlPageName: "",
                        originPolicyName: "",
                        hotlinkSecretKey: "",
                        hotlinkTimeToLive: 60,
                        hotlinkQueryArgument: "",
                    },
                ],
            };
        },
        getWafRuleStatusColor(wafRule) {
            return wafRule.isEnabled ? colorNames.green : colorNames.default;
        },
        editWafRule(index) {
            this.isEditWafRule = true;
            this.editingWafRuleIndex = index;
            this.isWafRuleModalShow = true;
            this.localValue = JSON.parse(JSON.stringify(this.value));
        },
        deleteWafRule(index) {
            this.localValue.splice(index, 1);
            this.$emit("input", this.localValue);
        },
        addWafRule() {
            if (this.value.length >= this.maxWafRuleListLength) {
                return this.$Message.error(
                    this.$t("intelligentProtectionSettings.reachMaxWafRuleListLength", {
                        maxWafRuleListLength: this.maxWafRuleListLength,
                    })
                );
            }
            const newRule = this.getEmptyWafRule();
            this.localValue.push(newRule);
            this.isEditWafRule = false;
            this.editingWafRuleIndex = this.localValue.length - 1;
            this.isWafRuleModalShow = true;
        },
        closeWafRuleModal() {
            this.isEditWafRule = false;
            this.editingWafRuleIndex = null;
            this.isWafRuleModalShow = false;
        },
        handleChildComponentValidate(props, callback) {
            let errorMessages = [];
            let validatedCount = 0;

            // 取出當前顯示的欄位
            const activeFormItemFields = this.$refs.wafRuleModalForm.fields.map((field) => field.prop);
            const activeProps = props.filter((p) => activeFormItemFields.includes(p));
            activeProps.forEach((p) => {
                this.$refs.wafRuleModalForm.validateField(p, (error) => {
                    validatedCount++;
                    if (error) {
                        errorMessages.push(error);
                    }
                    // 當最後一個欄位完成驗證時
                    if (validatedCount === activeProps.length) {
                        // 若 errorMessages 為空，代表全部通過
                        callback(errorMessages.length === 0);
                    }
                });
            });
        },
        cancelEditOrAddWafRule() {
            this.isWafRuleModalShow = false;
            this.$nextTick(() => {
                if (this.$refs.wafRuleModalForm) {
                    this.$refs.wafRuleModalForm.resetFields();
                }
                this.localValue = JSON.parse(JSON.stringify(this.value));
            });
        },
        async confirmEditOrAddWafRule() {
            const [rulesComponent] = this.$refs.rulesRef || [];
            const isChildValid = await rulesComponent.validateAndSyncAll();
            if (!isChildValid) {
                this.$Message.error(this.$t("intelligentProtectionSettings.wafRuleModalFormValidationError"));
                return;
            }

            const valid = await this.$refs.wafRuleModalForm.validate();
            if (!valid) {
                return this.$Message.error(this.$t("intelligentProtectionSettings.wafRuleModalFormValidationError"));
            }
            this.$emit("input", this.localValue);
            this.closeWafRuleModal();
        },
    },
};
</script>
<style scoped>
.wafRuleList-card-ios-radio-button-on {
    margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/wafRuleList/wafRuleList.vue